import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { ProxyOffButtonGroup } from './ProxyOffBtnGroup/ProxyOffButtonGroup';
import { ProxyOnButtonGroup } from './ProxyOnBtnGroup/ProxyOnButtonGroup';
import styles from './InvoiceReportsButtonGroup.module.scss';

const cx = classnames.bind(styles);

export type InvoiceReportsButtonGroupProps = {
  /** When true, show Proxy ON actions (dropdowns); when false, show Proxy OFF actions (links). */
  canAgentEntry: boolean;
  /** Report type id for "Create new" redirect. */
  reportTypeId?: string;
  /** cx class name for container */
  containerClassName?: string;
};

/** Wraps BaseButtonGroup (Export, Import) with either ProxyOn or ProxyOff action buttons. */
export const InvoiceReportsButtonGroup: FC<InvoiceReportsButtonGroupProps> =
  memo(({ canAgentEntry, reportTypeId, containerClassName }) => {
    return (
      <div
        className={cx('root', containerClassName)}
        data-testid='invoice-reports-button-group'
      >
        <div className={cx('buttons')}>
          {/* // add base button group here */}
          {canAgentEntry ? (
            <ProxyOnButtonGroup reportTypeId={reportTypeId} />
          ) : (
            <ProxyOffButtonGroup reportTypeId={reportTypeId} />
          )}
        </div>
      </div>
    );
  });

InvoiceReportsButtonGroup.displayName = 'InvoiceReportsButtonGroup';
